import { Editor, type NodeEntry, Transforms } from 'slate';

const MARK_CONTENT_INDEX = 2;

export const replaceWithMark = (editor: Editor, options) => {
  const { triggerKey, matchData, activeMarks, mark } = options;

  const node = {
    text: matchData[MARK_CONTENT_INDEX],
    ...activeMarks,
    [mark]: true,
  };

  Editor.insertNode(editor, node);
  Editor.removeMark(editor, mark);

  if (triggerKey.length > 0) {
    Editor.insertText(editor, triggerKey);
  }
};

export const revertMark = (
  editor: Editor,
  previousEntry: NodeEntry,
  options
) => {
  const [, previousPath] = previousEntry;
  const { triggerKey, matchData, mark } = options;

  Transforms.setNodes(editor, { [mark]: null }, { at: previousPath });

  const distance = matchData[MARK_CONTENT_INDEX].length + triggerKey.length;
  Transforms.delete(editor, { distance, unit: 'character', reverse: true });

  return true;
};
